import { isCustomNumber } from './NumberUtils';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import { Styles, StyleConstants } from '../Styles';
import Decimal from 'decimal.js';
import { Typography } from '@mui/material';

export const jsonToQueryString = (json) => {
    return '?' + 
        Object.keys(json).map(function(key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        }).join('&');
};

export const jsonToTable = (obj) => {    
    const rows = [];

    for (const key in obj) {
        let value = obj[key];

        if (value !== null) {
            if (!Array.isArray(value) && (String(value).indexOf('.') > -1) && (isCustomNumber(value))) {
                value = new Decimal(value).toFixed(1);
            }
        }

        rows.push(
            <TableRow key={key} sx={{ backgroundColor: StyleConstants.tableCellBgColor, border: '2px solid ' + StyleConstants.borderColor }}>
                <TableCell>
                    <Typography sx={{ whiteSpace: 'nowrap', width: '230px', height:'25px', margin: '0px', padding: '0px' }}>
                        {key}
                    </Typography>
                </TableCell>
                <TableCell sx={{ ...Styles.carBorderCellRight }}>
                    <Typography sx={{ whiteSpace: 'nowrap', width: '230px', height:'25px', margin: '0px', padding: '0px' }}>
                        {value}
                    </Typography>
                </TableCell>
            </TableRow>
        );
    }

    return (
        <TableContainer component={Paper}>
            <Table size='small' sx={{ border: '3px solid ' + StyleConstants.borderColor }}>
                <TableBody>
                    {rows}
                </TableBody>
            </Table>
        </TableContainer>
    );
};